import { CalculateVenue } from '@/domain/impact-calculate-venue/entities/calculate-venue.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Result = { projectId: number; calculate: CalculateVenue }[];

export const getSummaryImpactCalculateVenueForAllProjects = createAppAsyncThunk(
  'impactCalculateVenue/getSummaryImpactCalculateVenueForAllProjects',
  async (
    _,
    { extra: { impactCalculateVenueGateway, snackbarGateway } },
  ): Promise<Result> => {
    try {
      const result =
        await impactCalculateVenueGateway.getSummaryImpactCalculateVenueForAllProjects();
      return result;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCalculate.Message.error'));
}
